import { render, staticRenderFns } from "./StaffAudit.vue?vue&type=template&id=7aaea854&scoped=true&"
import script from "./StaffAudit.vue?vue&type=script&lang=js&"
export * from "./StaffAudit.vue?vue&type=script&lang=js&"
import style0 from "./StaffAudit.vue?vue&type=style&index=0&id=7aaea854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaea854",
  null
  
)

export default component.exports